<template>
  <BaseTemplate>
    <block>
      <h1>SMS認証が完了しました</h1>
      <div class="checkbox-image">
        <span class="check"><i class="far fa-check"></i></span>
      </div>
      <BlackGradationButton
        class="label-input nomt sms_button hanten"
        className="small"
        text="TOPへ戻る"
        @handleSquareBtnClick="btnGoToTop" />
    </block>
  </BaseTemplate>
</template>

<script>
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';

export default {
  components: {
    BaseTemplate,
    BlackGradationButton,
  },

  data: () => ({
    pageMode: 0,
  }),

  methods: {
    btnGoToTop() {
      this.$router.push({ path: '/' });
    },
  },
};
</script>

<style lang="scss" scoped>
block {
  margin: 40px auto 200px auto;
  max-width: 800px;
  display: block;
  @media screen and  (max-width: $tabletWidth) {
    padding: 0 20px;
  }
  h1 {
    font-size: 24px;
    text-align: center;
    margin-bottom: 30px;
  }
  .checkbox-image {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 40px;
    .check {
      color: #ef5656;
      border: solid 5px #ef5656;
      border-radius: 200px;
      width: 100px;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 60px;
    }
  }
  .sms_button {
    width: 300px;
    margin: auto;
  }
}
</style>
